var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCalendarSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1875 3.16699H12.5V1.33887C12.5 1.12793 12.2891 0.916992 12.0781 0.916992H11.7969C11.5508 0.916992 11.375 1.12793 11.375 1.33887V3.16699H4.625V1.33887C4.625 1.12793 4.41406 0.916992 4.20312 0.916992H3.92188C3.67578 0.916992 3.5 1.12793 3.5 1.33887V3.16699H1.8125C0.863281 3.16699 0.125 3.94043 0.125 4.85449V17.2295C0.125 18.1787 0.863281 18.917 1.8125 18.917H14.1875C15.1016 18.917 15.875 18.1787 15.875 17.2295V4.85449C15.875 3.94043 15.1016 3.16699 14.1875 3.16699ZM1.8125 4.29199H14.1875C14.4688 4.29199 14.75 4.57324 14.75 4.85449V6.54199H1.25V4.85449C1.25 4.57324 1.49609 4.29199 1.8125 4.29199ZM14.1875 17.792H1.8125C1.49609 17.792 1.25 17.5459 1.25 17.2295V7.66699H14.75V17.2295C14.75 17.5459 14.4688 17.792 14.1875 17.792Z",
    fill: "#199690"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendarSmall);
export default __webpack_public_path__ + "static/media/ic-calendar-small.b15ba261dc8e34aba86fd9cfca668f83.svg";
export { ForwardRef as ReactComponent };